export const API_URL = 'https://api.bigcommerce.com/stores';
export const CATEGORY_ENDPOINT = 'v3/catalog/trees/categories';
export const CATEGORY_TREE_ENDPOINT = 'v3/catalog/trees';

export const CART_ENDPOINT = 'v3/carts';
export const CHECKOUT_ENDPOINT = 'v3/checkouts';

export const SORTORDER_ENDPOINT = 'v3/catalog/categories';
export const PRODUCT_ENDPOINT = 'v3/catalog/products';
export const WISHLIST_ENDPOINT = 'v3/wishlists';
export const BRAND_ENDPOINT = 'v3/catalog/brands';
export const FILTERS_ENDPOINT = 'v3/settings/search/filters';
export const CATEGORIES_ENDPOINT = 'v3/catalog/categories';
export const CATEGORY_IDS_INFILTERS_PRODUCT_TYPE = [
  170, 132, 166, 167, 163, 168, 162, 169, 137, 123, 145, 124, 154, 127, 148, 135, 108, 111, 113,
  139, 106, 120, 117, 136, 164, 150, 118, 100, 165, 101, 98, 83, 92, 81, 96, 24, 66, 79,
];

export const defaultSort = {
  title: 'RELEVANCE',
  slug: null,
  sortKey: 'RELEVANCE',
  reverse: false,
};

export const sorting = [
  defaultSort,
  {
    title: 'TRENDING',
    slug: 'trending-desc',
    sortKey: 'BEST_SELLING',
    reverse: false,
  }, // asc
  {
    title: 'NEWEST',
    slug: 'latest-desc',
    sortKey: 'CREATED_AT',
    reverse: true,
  },
  {
    title: 'LOWEST PRICE',
    slug: 'price-asc',
    sortKey: 'PRICE',
    reverse: false,
  }, // asc
  {
    title: 'HIGHEST PRICE',
    slug: 'price-desc',
    sortKey: 'PRICE',
    reverse: true,
  },
  {
    title: 'FEATURED',
    slug: 'featured',
    sortKey: 'FEATURED',
    reverse: false,
  },
];

export const SIDE_DRAWER_STATIC_SHOP_FILTERS = [
  {
    key: 'sort_by',
    name: 'Sort By',
    // options: sorting,
    options: [
      {
        title: 'RECOMMENDED',
        slug: null,
      },
      {
        title: 'NEWEST',
        slug: 'created_at',
      },
      {
        title: 'OLDEST',
        slug: 'created_at',
      },
      {
        title: 'LOWEST PRICE',
        slug: 'price',
      },
      {
        title: 'HIGHEST PRICE',
        slug: 'price',
      },
    ],
  },
  {
    key: 'price',
    name: 'Price',
    options: [
      { title: '0 - 250 AED', slug: '[0,250]' },
      { title: '250 - 500 AED', slug: '[250,500]' },
      { title: '500 - 750 AED', slug: '[500,750]' },
      { title: '750 - 1000 AED', slug: '[750,1000]' },
      { title: '1000+ AED', slug: '[1000,100000]' },
    ],
  },

  // {
  //   key: "collection",
  //   name: "COLLECTION",
  //   options: [
  //     { title: "Basma Collection", slug: "100" },
  //     { title: "Serena Ramadan Collection", slug: "101" },
  //     { title: "Jessie Collection", slug: "124" },
  //     { title: "Tamara Collection", slug: "106" },
  //     { title: "Serena Collection", slug: "108" },
  //   ],
  // },
];


export const sizes = [
    {
        title: "UK",
        slug: "UK",
        value: "UK",
        values: [
            { label: "4", value: "UK-4" },
            { label: "6", value: "UK-6" },
            { label: "8", value: "UK-8" },
            { label: "10", value: "UK-10" },
            { label: "12", value: "UK-12" },
            { label: "14", value: "UK-14" },
            { label: "16", value: "UK-16" },
            { label: "18", value: "UK-18" },
            { label: "20", value: "UK-20" },
            { label: "22", value: "UK-22" },
            {
                label: "S",
                value: "UK-S",
            },
            {
                label: "M",
                value: "UK-M",
            },
            {
                label: "L",
                value: "UK-L",
            },
            {
                label: "XL",
                value: "UK-XL",
            },
            {
                label: "XXL",
                value: "UK-XXL",
            },
            {
                label: "3XL",
                value: "UK-3XL",
            },
            {
                label: "4XL",
                value: "UK-4XL",
            },
            {
                label: "5XL",
                value: "UK-5XL",
            },
        ],
    },
    {
        title: "US",
        slug: "US",
        value: "US",
        values: [
            { label: "0", value: "US-0" },
            { label: "2", value: "US-2" },
            { label: "4", value: "US-4" },
            { label: "6", value: "US-6" },
            { label: "8", value: "US-8" },
            { label: "10", value: "US-10" },
            { label: "12", value: "US-12" },
            { label: "14", value: "US-14" },
            { label: "16", value: "US-16" },
            { label: "18", value: "US-18" },
            { label: "S", value: "US-S" },
            { label: "M", value: "US-M" },
            { label: "L", value: "US-L" },
            { label: "XL", value: "US-XL" },
            { label: "XXL", value: "US-XXL" },
            { label: "3XL", value: "US-3XL" },
            { label: "4XL", value: "US-4XL" },
            { label: "5XL", value: "US-5XL" },
        ],
    },
    {
        title: "EU",
        slug: "EU",
        value: "EU",
        values: [
            { label: "32", value: "EU-32" },
            { label: "34", value: "EU-34" },
            { label: "36", value: "EU-36" },
            { label: "38", value: "EU-38" },
            { label: "40", value: "EU-40" },
            { label: "42", value: "EU-42" },
            { label: "44", value: "EU-44" },
            { label: "46", value: "EU-46" },
            { label: "48", value: "EU-48" },
            { label: "50", value: "EU-50" },
            { label: "S", value: "EU-S" },
            { label: "M", value: "EU-M" },
            { label: "L", value: "EU-L" },
            { label: "XL", value: "EU-XL" },
            { label: "XXL", value: "EU-XXL" },
            { label: "3XL", value: "EU-3XL" },
            { label: "4XL", value: "EU-4XL" },
            { label: "5XL", value: "EU-5XL" },
        ],
    },
    {
        title: "Standard Labels",
        slug: "Standard",
        value: "Standard Labels",
        values: [
            { label: "XXS", value: "Standard-XXS" },
            { label: "XS", value: "Standard-XS" },
            { label: "S", value: "Standard-S" },
            { label: "M", value: "Standard-M" },
            { label: "L", value: "Standard-L" },
            { label: "XL", value: "Standard-XL" },
            { label: "XXL", value: "Standard-XXL" },
            { label: "3XL", value: "Standard-3XL" },
            { label: "4XL", value: "Standard-4XL" },
            { label: "5XL", value: "Standard-5XL" },
        ],
    },
];



export const sizeMapping = [
    { US: "0", UK: "4", EU: "32", Standard: "XXS" },
    { US: "2", UK: "6", EU: "34", Standard: "XS" },
    { US: "4", UK: "8", EU: "36", Standard: "S" },
    { US: "6", UK: "10", EU: "38", Standard: "M" },
    { US: "8", UK: "12", EU: "40", Standard: "L" },
    { US: "10", UK: "14", EU: "42", Standard: "XL" },
    { US: "12", UK: "16", EU: "44", Standard: "2XL" },
    { US: "14", UK: "18", EU: "46", Standard: "3XL" },
    { US: "16", UK: "20", EU: "48", Standard: "4XL" },
    { US: "18", UK: "22", EU: "50", Standard: "5XL" },
];
